import { IS_WEB } from 'constants/platform'

export const centsToDollars = (cents: number) => {
  const dollars = cents / 100
  return IS_WEB
    ? dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    : `$${dollars}.00`
}
